import { Tooltip } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import LocationKO from '@material-ui/icons/NotListedLocation';
import LocationWARNING from '@material-ui/icons/Warning';
import LocationOK from '@material-ui/icons/WhereToVote';

const GeometriesField = (props) => {
    const translate = useTranslate();
    const record = props?.record;
    return <div className="geometries">
        {record?.geometryFilledTotal > 0 && <Tooltip title={translate("resources.geometry.filled")}>
            <strong>
                <LocationOK className="green" />
                {record?.geometryFilledTotal}
            </strong>
        </Tooltip>}
        {record?.geometryEmptyTotal > 0 && <Tooltip title={translate("resources.geometry.empty")}>
            <strong>
                <LocationKO color="disabled" />
                {record?.geometryEmptyTotal}
            </strong>
        </Tooltip>}
        {record?.geometryFailedTotal > 0 && <Tooltip title={translate("resources.geometry.failed")}>
            <strong>
                <LocationWARNING color="error" />
                {record?.geometryFailedTotal}
            </strong>
        </Tooltip>}
    </div>;
};

export default GeometriesField;